import { Role } from './../_models/role.model';

// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud/models/query-models/query-results.model';
// State
import { RolesState } from '../_reducers/role.reducers';
import * as fromRole from '../_reducers/role.reducers';
import { each } from 'lodash-es';

export const selectRolesState = createFeatureSelector<RolesState>('roles');

export const selectRoleById = (roleId: number) =>
  createSelector(selectRolesState, (rolesState) => rolesState.entities[roleId]);

export const selectAllRoles = createSelector(selectRolesState, (rolesState) => rolesState.allRoles);

export const selectAllCompanyRoles = createSelector(selectRolesState, fromRole.selectAll);

export const selectAllRolesIds = createSelector(selectRolesState, fromRole.selectIds);

export const allRolesLoaded = createSelector(
  selectRolesState,
  (rolesState) => rolesState.isAllRolesLoaded,
);

export const selectRolesPageLoading = createSelector(
  selectRolesState,
  (rolesState) => rolesState.listLoading,
);

export const selectRolesActionLoading = createSelector(
  selectRolesState,
  (rolesState) => rolesState.actionsloading,
);

export const selectLastCreatedRoleId = createSelector(
  selectRolesState,
  (rolesState) => rolesState.lastCreatedRoleId,
);

export const selectRolesShowInitWaitingMessage = createSelector(
  selectRolesState,
  (rolesState) => rolesState.showInitWaitingMessage,
);

export const selectRoleLatestSuccessfullAction = createSelector(
  selectRolesState,
  (rolesState) => rolesState.latestSuccessfullAction,
);

export const selectRoleError = createSelector(selectRolesState, (rolesState) => rolesState.error);

export const selectQueryResult = createSelector(selectRolesState, (rolesState) => {
  const items: Role[] = [];
  each(rolesState.ids, (ele) => {
    const index: number = +ele;
    items.push(rolesState.entities[index]);
  });
  return new QueryResultsModel(items, rolesState.totalCount);
});
